import { useState, useEffect } from 'react';
import Sidebar from './components/Sidebar';

export default function Dashboard() {
  const [currentDate, setCurrentDate] = useState('');

  useEffect(() => {
    const today = new Date();
    const options: Intl.DateTimeFormatOptions = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric', 
      weekday: 'long' 
    };
    setCurrentDate(today.toLocaleDateString('ko-KR', options));
  }, []);

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <div className="p-8 max-w-7xl mx-auto">
          
          {/* 1. 웰컴 배너 섹션 */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-400 rounded-2xl shadow-lg p-8 mb-8 text-white">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
              <div>
                <p className="text-blue-100 mb-2 font-medium">{currentDate}</p>
                <h1 className="text-3xl md:text-4xl font-bold mb-4">
                  환영합니다👋
                </h1>
                <p className="text-blue-100 text-lg max-w-2xl leading-relaxed">
                  오늘도 웨드민과 함께 행복한 순간을 만들어가요.<br/>
                  좌측 메뉴를 선택하여 업무를 시작해주세요.
                </p>
              </div>
              <div className="hidden md:block opacity-20">
                <i className="ri-building-4-line text-9xl"></i>
              </div>
            </div>
          </div>

          {/* 2. 정보 섹션 (공통 영역으로 대체) */}
          <div className="grid grid-cols-1 gap-6">
            {/* 시스템 문의 / 고객센터 위젯 */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 h-full">
              <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                <i className="ri-customer-service-2-line mr-2 text-green-500"></i>
                시스템 문의
              </h3>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                서비스 이용 중 불편한 점이나 문의사항이 있으신가요?<br/>
                고객센터로 연락주시면 신속하게 도와드리겠습니다.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="http://pf.kakao.com/_xfxnKyn" target="_blank" rel="noopener noreferrer"
                  className="flex-1 bg-yellow-50 rounded-lg p-4 flex items-center hover:bg-yellow-100 transition-colors cursor-pointer">
                  <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-sm text-yellow-600 mr-3">
                    <i className="ri-kakao-talk-fill text-xl"></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">카카오 채널</p>
                    <p className="text-sm font-bold text-gray-800">카카오톡으로 문의하기</p>
                  </div>
                </a>

                <div className="flex-1 bg-gray-50 rounded-lg p-4 flex items-center">
                  <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-sm text-green-600 mr-3">
                    <i className="ri-time-line text-xl"></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">운영시간</p>
                    <p className="text-sm font-bold text-gray-800">평일 09:00 - 18:00</p>
                  </div>
                </div>
              </div>
            </div>

          </div>

          {/* 하단 안내 메시지 */}
          <div className="mt-12 text-center py-10 border-t border-gray-200">
            <p className="text-gray-400 text-sm">
              <i className="ri-information-line mr-1"></i>
              관리자 권한에 따라 접근 가능한 메뉴가 다를 수 있습니다. 권한 문의는 관리자에게 요청해주세요.
            </p>
          </div>

        </div>
      </main>
    </div>
  );
}
